"use strict";
var carbucks = carbucks || {};
const siteHeader = document.getElementById("js-site-header");

carbucks.siteHeader =
  carbucks.siteHeader ||
  (function() {
    function init() {
      if (siteHeader && !siteHeader.classList.contains("site-header--scroll")) {
        let lastScrollTop = 0;

        setTimeout(() => {
          if (window.scrollY > 0) {
            siteHeader.classList.add("site-header--scroll");
          }
        }, 100);
        document.addEventListener(
          "scroll",
          function() {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (lastScrollTop > 150) {
              siteHeader.classList.add("site-header--scroll");
            } else {
              siteHeader.classList.remove("site-header--scroll");
            }
            lastScrollTop = st <= 0 ? 0 : st;
          },
          false
        );
      }
    }
    return {
      init: init,
    };
  })();
